import { animated } from '@react-spring/web';
import { useLocation } from 'react-router-dom';
import cn from '../../../app/utils/cn';
import Tooltip from '../Tooltip';
import { useNavItemController } from './useNavItemController';

interface INavItemProps {
  description: string;
  children?: React.ReactNode;
  selected?: boolean;
  color?: 'primary' | 'danger' | 'ghost';
  navigateTo: string;
  onClick?: () => void;
}

const AnimatedSection = animated('section');

export default function NavItem({
  description,
  children,
  color,
  navigateTo,
  onClick,
}: INavItemProps) {
  const {
    cnSelected,
    navItemAnimation,
    isTooltipVisible,
    sidebarIsOpen,
    showTooltip,
    hideTooltip,
  } = useNavItemController();

  const loc = useLocation();
  const selected = navigateTo === loc.pathname;

  return (
    <li>
      <AnimatedSection
        className={cn('w-full', !sidebarIsOpen && 'items-center')}
        style={navItemAnimation}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}
      >
        <Tooltip
          show={!sidebarIsOpen && isTooltipVisible}
          text={description}
          color={color}
        >
          <div
            className={cn(
              'flex items-center gap-2 rounded-md p-2 text-sm text-green-900 dark:text-green-200',
              selected && cnSelected,
              !selected &&
                'hover:bg-grey-0/50 dark:hover:bg-grey-700/50 cursor-pointer',
            )}
            onClick={() => {
              hideTooltip();
              if (!selected) onClick?.();
            }}
          >
            {children}
            <p
              className={cn(
                color === 'danger' && 'text-red-600! dark:text-red-400!',
              )}
            >
              {sidebarIsOpen && description}
            </p>
          </div>
        </Tooltip>
      </AnimatedSection>
    </li>
  );
}
